import { render, staticRenderFns } from "./goodsGet.vue?vue&type=template&id=7f8b7cc9&"
import script from "./goodsGet.vue?vue&type=script&lang=js&"
export * from "./goodsGet.vue?vue&type=script&lang=js&"
import style0 from "./goodsGet.vue?vue&type=style&index=0&id=7f8b7cc9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports